import { journal } from 'shared/actions/globals';
import { fetchRubrics } from 'shared/network/journal';
import leasingLinksPopularCities from 'shared/constants/json/leasingLinksPopularCities.json';

export const redirectToLoginIfNotLoggedIn = ({ next, store }) => {
  const token = store.getState().user.token;

  if (!token) {
    return {
      redirect: '/login/',
    };
  }

  return next();
};

export const validateRedirectUrl = url => {
  if (!url) {
    return null;
  }

  const ALLOWED_HOSTS = [
    'https://sto.avtobazar.ua',
    'http://sto.desktop.s3.ua',
    'http://desktop.s3.ua',
    'http://localhost',
  ];

  if (!url.startsWith('/') && !ALLOWED_HOSTS.some(host => url.startsWith(host))) {
    return null;
  }

  return url.replace(/^\/+/, '/');
};

export const loggedInRedirect = ({ next, query, store }) => {
  const { user } = store.getState();
  const { redirectUrl } = query;

  if (user && user.token) {
    return {
      redirect: validateRedirectUrl(redirectUrl) || '/my',
    };
  }

  return next();
};

export const fetchJournalRubrics = async ({ store, fetch }) => {
  const rubrics = await (store.getState().globals.journal.rubrics || fetchRubrics(fetch));

  store.dispatch(journal.setRubrics(rubrics));

  return undefined;
};

export const isValidLeasingLocationRoute = (route, location) => {
  if (route !== '/leasing/') return true;
  const slug = `${route}${location}/`;
  const avaliable = leasingLinksPopularCities.items.find(item => item.slug === slug);
  return avaliable;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/routes.js